import SplitType from "split-type";

function wrapElement(node, className) {
  if (!node || node.parentNode?.classList?.contains(className)) {
    return;
  }

  const wrapper = document.createElement("div");
  wrapper.classList.add(className);
  node.parentNode.insertBefore(wrapper, node);
  wrapper.appendChild(node);
}

export function initializeSplitText(content) {
  if (!content) {
    return null;
  }

  if (content.dataset.splitInitialized === "true") {
    return {
      titleTopChars: [...content.querySelectorAll('[data-content="text-top"] .char')],
      titleBottomChars: [...content.querySelectorAll('[data-content="text-bottom"] .char')],
      leftLines: [...content.querySelectorAll('[data-content="text-left"] .line')],
      rightLines: [...content.querySelectorAll('[data-content="text-right"] .line')],
    };
  }
  content.dataset.splitInitialized = "true";

  const titleTopNodes = [
    ...content.querySelectorAll('[data-content="text-top"] .title-big'),
  ];
  const titleBottomNodes = [
    ...content.querySelectorAll('[data-content="text-bottom"] .title-big'),
  ];
  const leftNodes = [
    ...content.querySelectorAll(
      '[data-content="text-left"] .title-small, [data-content="text-left"] .paragraph',
    ),
  ];
  const rightNodes = [
    ...content.querySelectorAll(
      '[data-content="text-right"] .title-small, [data-content="text-right"] .paragraph',
    ),
  ];

  const titleTopSplits = titleTopNodes.map(
    (node) => new SplitType(node, { types: "chars" }),
  );
  const titleBottomSplits = titleBottomNodes.map(
    (node) => new SplitType(node, { types: "chars" }),
  );

  titleTopSplits.forEach((split) => {
    split.chars?.forEach((char) => wrapElement(char, "char-wrap"));
  });

  titleBottomSplits.forEach((split) => {
    split.chars?.forEach((char) => wrapElement(char, "char-wrap"));
  });

  const leftSplits = leftNodes.map(
    (node) => new SplitType(node, { types: "lines" }),
  );
  const rightSplits = rightNodes.map(
    (node) => new SplitType(node, { types: "lines" }),
  );

  [...leftSplits, ...rightSplits].forEach((split) => {
    split.lines?.forEach((line) => wrapElement(line, "line-wrap"));
  });

  const titleTopChars = titleTopSplits.flatMap((split) => split.chars ?? []);
  const titleBottomChars = titleBottomSplits.flatMap(
    (split) => split.chars ?? [],
  );
  const leftLines = leftSplits.flatMap((split) => split.lines ?? []);
  const rightLines = rightSplits.flatMap((split) => split.lines ?? []);

  return {
    titleTop: titleTopSplits,
    titleBottom: titleBottomSplits,
    left: leftSplits,
    right: rightSplits,
    titleTopChars,
    titleBottomChars,
    leftLines,
    rightLines,
  };
}
